
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/facilities",
      function () {
        return require("private-next-pages/facilities/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/facilities"])
      });
    }
  